import { SvgIcon } from "@mui/material";
import { IIconProps } from "@/models";
import { memo } from "react";

const ArrowLeftIcon = ({ sx, className, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="10"
      viewBox="0 0 11 10"
      fill="none"
      className={"qi-icon qi-icon-arrow-left " + className}
      sx={{ fontSize: "inherit", ...sx }}
      {...otherProps}
    >
      <g opacity="0.9">
        <g clipPath="url(#clip0_776_6151)">
          <path
            d="M6.91915 9.05336L3.28062 5.41483C3.06011 5.19431 3.06011 4.9738 3.28062 4.75328C3.50114 4.53276 3.72166 4.53276 3.94217 4.75328L7.58071 8.39181C7.80122 8.61233 7.80122 8.83285 7.58071 9.05336C7.36019 9.27388 7.13967 9.27388 6.91915 9.05336Z"
            fill="#333F48"
          />
          <path
            d="M7.58071 1.67264L3.94218 5.31117C3.72166 5.53169 3.50114 5.53169 3.28063 5.31117C3.06011 5.09066 3.06011 4.87014 3.28063 4.64962L6.91916 1.01109C7.13967 0.790574 7.36019 0.790574 7.58071 1.01109C7.80122 1.23161 7.80122 1.45213 7.58071 1.67264Z"
            fill="#333F48"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_776_6151">
          <rect
            x="10.8125"
            y="9.94531"
            width="9.82353"
            height="9.82353"
            rx="4.91176"
            transform="rotate(-180 10.8125 9.94531)"
            fill="white"
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default memo(ArrowLeftIcon);
